import { Button, Flex } from "antd";
import { useNavigate } from "react-router-dom";
import { SettingOutlined } from "@ant-design/icons";
import RingotelLogo from "../../assets/images/logo/ringotel.svg";
import WebhookLogo from "../../assets/images/logo/webhook-integration.png";
import "./integration.css"

const IntegrationsPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px", width: "100%" }}>
      <Flex gap={16} wrap>
        <div style={{ width: 300, borderRadius: "10px", padding: "5px", background: "#fff" }}>
          <img alt="Ringotel" src={RingotelLogo} style={{ width: "260px", margin: "25px" }}></img>
          <Button style={{ width: "100%" }} type="primary" icon={<SettingOutlined />} onClick={() => navigate("/ringotel-users")}></Button>
        </div>

        <div style={{ width: 300, borderRadius: "10px", padding: "7px", background: "#fff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "space-between" }}>
          <img alt="Webhook" src={WebhookLogo} style={{ width: "260px", marginTop: "9px" }} />
          <Button style={{ width: "100%" }} type="primary" icon={<SettingOutlined />} onClick={() => navigate("/webhooks")} />
        </div>
      </Flex>
    </div>
  );
};

export default IntegrationsPage;
